<template>
  <v-card flat dense max-width="600">
    <v-card-title>
      <div class="d-inline-flex align-baseline">
        <span class="mr-4">{{
          $t('INHABITANT_CHANGES.CHECK_OUT_REQUEST')
        }}</span>
      </div>
      <v-spacer />
      <span class="text-body-2">{{ $t('ITEM.STATUS') }}</span>
      <div>
        <v-select
          v-model="request.status_id"
          name="status_id"
          :items="statusesList"
          item-value="id"
          item-text="name"
          small-chips
          hide-details
          dense
          flat
          solo
          style="width: 170px"
          :error-messages="errors.status_id"
          @change="clearErrorByName('status_id')"
        >
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              :color="item.color"
              :input-value="selected"
              text-color="white"
              small
              v-bind="attrs"
              @click="select"
            >
              {{ item.name }}
            </v-chip>
          </template>
        </v-select>
      </div>
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <person-details class="pa-4 mb-4" :request="request" rounded />
      <v-form ref="form" v-model="valid" lazy-validation>
        <check-out
          v-if="request.id"
          v-model="request.data"
          :readonly="!editable"
          :errors="errors.get('data')"
          @update-prop="clearErrorByName($event, 'data')"
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <slot name="buttons" :valid="valid" :cancel="cancel" :update="update">
        <v-btn large outlined depressed color="grey" @click="cancel">{{
          $t('BUTTON.CANCEL')
        }}</v-btn>
        <v-spacer />
        <v-btn
          large
          depressed
          color="primary"
          :disabled="!isEnabledUpdateButton"
          @click="validableUpdate"
        >
          {{ $t('BUTTON.UPDATE') }}
        </v-btn>
      </slot>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import CheckOut from '@/modules/persons/components/forms/CheckOut';
import request from '@/modules/inhabitant_changes/components/requests/mixins/request';
import PersonDetails from '@/modules/inhabitant_changes/components/PersonDetails';

export default {
  name: 'RequestCheckOut',

  components: {
    CheckOut,
    PersonDetails
  },

  mixins: [request, errors, i18nRefreshData],

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    request: {
      data: {},
      status: {},
      person: {}
    },
    result: {}
  }),

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapActions('inhabitant_changes', [
      'getById',
      'getStatuses',
      'resolveRequest'
    ]),

    refreshData() {
      this.getById(this.id).then(({ data: { data: request } }) => {
        const { person, data } = request;

        this.request = {
          ...request,
          data: {
            ...data,
            person,
            inhabitant: {
              ...person.inhabitant,
              ...data.inhabitant
            }
          }
        };
      });

      this.getStatuses().then(({ data }) => {
        this.statuses = data.data;
      });
    },

    validate() {
      return this.$refs.form.validate();
    },

    update() {
      this.resolveRequest({
        id: this.id,
        data: this.request
      })
        .then(() => {
          this.$emit('updated');
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    },

    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>
